import { Controller } from "@hotwired/stimulus"
import queryString from 'query-string'
import { mergeParams, getParams } from '../tools/h_params'
import axios from "axios";

axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-TOKEN": document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content"),
};

export default class extends Controller {
  static targets = ['confirmModal', 'modalTitle']

  connect(){
  }

  toggleConnection(event){
    const params = event.params
    const isActive = params.isActive === true || params.isActive === 'true'

    if (isActive) {
      this.pendingUrl = params.updateUrl
      this.modalTitleTarget.textContent = `「${params.accountName}」の連携を解除しますか？`
      this.confirmModalTarget.classList.add('is-active')
    } else {
      this._callApi(params.updateUrl)
    }
  }

  async executeToggle(){
    this.closeConfirmModal()
    await this._callApi(this.pendingUrl)
  }

  closeConfirmModal(){
    this.confirmModalTarget.classList.remove('is-active')
  }

  async _callApi(url){
    const res = await axios.patch(url)

    if(res.data.is_complete) {
      location.reload()
    }else{
      alert(res.data.error_message.join('\n'))
    }
  }
}
